import { GET_PT_DEPARTEMENT } from '_revamp/redux/action/admin/departement';

const initialState = {
  list: [],
  detail: [],
};

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PT_DEPARTEMENT: {
      if (payload.detail) {
        return {
          ...state,
          detail: payload,
        };
      }
      return {
        ...state,
        list: payload.data,
      };
    }

    default:
      return state;
  }
};

export default auth;
